<template>
  <div>
    <div class="sayfahead tek">
      <h1>Kullanıcı İşlemleri</h1>
      <el-button type="info" size="small" class="YeniBtn" @click="this.YeniBtn">
        {{Sayfa.ButtonAdi}}
      </el-button>
    </div>
    <div class="icerik">
      <el-table
        v-if="Liste"
        :data="Liste.filter(data => !search || data.AdSoyad.toLowerCase().includes(search.toLowerCase()) || data.Email.toLowerCase().includes(search.toLowerCase()))"
        :default-sort="{prop: 'AdSoyad', order: 'ascending'}"
        class="golgetable">

        <el-table-column
          label="Ad Soyad"
          prop="AdSoyad">
        </el-table-column>
        <el-table-column
          label="Email"
          prop="Email"
          width="300">
        </el-table-column>
        <el-table-column
          label="Telefon"
          prop="Telefon"
          width="120">
        </el-table-column>
        <el-table-column
          label="Durum"
          prop="DurumText"
          width="100">
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="medium"
              :placeholder="Arama"/>
          </template>
          <template slot-scope="scope">
            <el-button-group>
              <el-tooltip class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <i
                  class="feather-edit-2  tableibtn text-primary"
                  @click="DuzenleBtn(scope.row)">
                </i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="Sayfa.Adi"
                          placement="top-start">
                <i
                  class="feather-airplay tableibtn text-success"
                  @click="$router.push('/kullanici/'+scope.row.id)">
                </i>
              </el-tooltip>

            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <FormModal :data="FormData" :ModalOlayi="ModalOlayi" :Baslik="Baslik"
                 @ModalOlayi="SayfaYukle"></FormModal>

    </div>
  </div>
</template>

<script>
  import FormModal from "../../components/Pack/Kulanici/FormModal";

  export default {
    components: {FormModal},
    data() {
      return {
        ModalOlayi: false,
        Baslik: null,
        Liste: [],
        FormData: {
          AdSoyad: null,
          Email: null,
          Telefon: null,
          durum: null,
          disabled: false,
          span: 8,
          Yetki: {
            yonetim: "0",
            vezne: "0",
            muhasebe: "0",
            kasa: "0",
            raporlama: "0",
            icra: "0",
            iletisim: "0",
            iptal: "0",
            spesiyal: "0",
            entegrasyon: "0",
            MakbuzIptal: "0",
            KVKK: "0",
            VezneTarih: "0",
            NotArsiv: "0",
          }
        },
        search: '',
        SeciliBina: null,
        Arama: 'Arama yapın',
        Sayfa: {
          ButtonAdi: 'Kulanıcı Ekle',
          DuzenleAdi: 'Düzenle',
          SilAdi: 'Pasif',
          Button: null,
          Adi: 'Kullanıcı Detay',
          Menu: [],
          MenuDisplay: null
        },
      }
    },
    methods: {
      SayfaYukle() {
        this.ModalOlayi = false;
        this.$store.dispatch("Get", {
          path: 'kullanici/l/'
        })
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })
      },
      YeniBtn() {
        this.ModalOlayi = true;
        this.Baslik = 'Kullanıcı Ekle';
        this.FormData = {
          AdSoyad: null,
          Email: null,
          Telefon: null,
          durum: null,
          disabled: false,
          span: 8,
          Yetki: {
            yonetim: "0",
            vezne: "0",
            muhasebe: "0",
            kasa: "0",
            raporlama: "0",
            icra: "0",
            iletisim: "0",
            iptal: "0",
            spesiyal: "0",
            entegrasyon: "0",
            MakbuzIptal: "0",
            KVKK: "0",
            VezneTarih: "0",
            NotArsiv: "0",
          },
          TahsilatMerkezi : {
            Kasa_id: null,
            Limit: null,
            Komisyon: null,
            Tutar: null
          }
        }
      },
      DuzenleBtn(Veri) {
        this.Baslik = Veri.AdSoyad + ' Düzenle';
        this.ModalOlayi = true;
        Veri.span = 6;
        Veri.disabled = true;
        if (Veri.Yetki == null) {
          Veri.Yetki = {
            yonetim: "0",
            vezne: "0",
            muhasebe: "0",
            kasa: "0",
            raporlama: "0",
            icra: "0",
            iletisim: "0",
            iptal: "0",
            spesiyal: "0",
            entegrasyon: "0",
            MakbuzIptal: "0",
            KVKK: "0",
            VezneTarih: "0",
            NotArsiv: "0",

          }
        }
        this.FormData = Veri

      },
    },
    mounted() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Kullanici/index.vue